import { useEffect, useState } from "react";

/** Subscribes to a media query. Used where a breakpoint has to change behaviour, not just styling. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Tailwind's `md`. Below this the shell switches to stacked, off-canvas behaviour. */
export const useIsMobile = () => !useMediaQuery("(min-width: 768px)");
